import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import "../../Users/User.css"; // Assuming you have some basic CSS here
import { ViewCategoryDataList } from '../../../Apis/Setting';

function View(props) {
  document.title = "Category | View";
  let navigate = useNavigate();
  let location = useLocation();
  const params = useParams();
  const MasterID = params?.zid;

  let FilterCategoryViewtData = location.state.FilterCategoryViewtData;
  const [MasterExtraDetails, setMasterExtraDetails] = useState([]);
  const [loading, setLoading] = useState(true); // State to manage loader

  const fetchData = async () => {
  try {
      const filterviewData = await ViewCategoryDataList(MasterID);
      setMasterExtraDetails(filterviewData?.data[0]);
    }

     catch (error) {
      console.error("Error fetching charger data:", error);
    } finally {
      setLoading(false); // Stop the loader when data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log("data", MasterExtraDetails);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-sm-12">
          <div className="card mt-4 p-4">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <h2 className="text-center">Category Details</h2>

                {/* Centered Image */}
                {MasterExtraDetails?.master_image && (
                  <div className="text-center mb-4">
                    <img
                      src={MasterExtraDetails.imageURL}
                      alt="Station"
                      style={{
                        width: '200px',
                        height: '200px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        border: '3px solid #ddd'
                      }}
                    />
                  </div>
                )}

                <div className="row">
                  <div className="col-sm-6">
                    <p><strong>Category Name:</strong> {MasterExtraDetails?.title}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Slug:</strong> {MasterExtraDetails?.slug}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Description:</strong> {MasterExtraDetails?.description}</p>
                  </div> 
                  <div className="col-sm-6">
                    <p><strong>Status:</strong> {MasterExtraDetails?.status}</p>
                  </div>
                 <div className="col-sm-6">
                    <p><strong>Created Date:</strong> {MasterExtraDetails?.createdAt}</p>
                  </div>
                 <div className="col-sm-6">
                    <p><strong>Updated Date:</strong> {MasterExtraDetails?.updatedAt}</p>
                  </div>
                    <div className="col-sm-6">
                    <p><strong>Updated By:</strong> {MasterExtraDetails?.updated_by[0]?.name}</p>
                  </div>
                
                  <div className="col-sm-6">
  <p>
    <strong>Created By:</strong>{" "}
    {Array.isArray(MasterExtraDetails?.created_by) && MasterExtraDetails?.created_by.length > 0 
      ? `${MasterExtraDetails.created_by[0].name} (${MasterExtraDetails.created_by[0].email})`
      : "No Creator Info"}
  </p>
</div>

<div className="col-sm-6">
  <p>
    <strong>Corporate Name:</strong>{" "}
    {Array.isArray(MasterExtraDetails?.corporate_id) && MasterExtraDetails?.corporate_id.length > 0 
      ? `${MasterExtraDetails.corporate_id[0].corporate_name} (${MasterExtraDetails.corporate_id[0].email})`
      : "No Corporate Info"}
  </p> 
</div>

                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default View;
